import { SortActions, SortActionTypes } from '@app/core/ngrx/actions/sort.actions';

/**
 * SortState
 */
export interface SortState {
  sortBy: any;
}

/**
 * SORT_INITIAL_STATE
 * @type {{sortBy: string}}
 */
export const SORT_INITIAL_STATE: SortState = {
  sortBy: { sortDirection: null, sortField: null },
};

/**
 * sortReducer
 * @param {SortState} state
 * @param {SortActions} action
 * @returns {SortState}
 */
export const sortReducer = (state: SortState = SORT_INITIAL_STATE, action: SortActions): SortState => {
  switch (action.type) {
    case SortActionTypes.LOAD_SORT_BY:
      return {
        ...state,
        sortBy: action.payload,
      };
    case SortActionTypes.CLEAR_SORT_BY:
      return {
        ...state,
        sortBy: { sortDirection: 'asc', sortField: 'orderDate' },
      };
    default:
      return state;
  }
};
